<template lang='pug'>
  div
    v-card.box(v-if='loading')
      v-container(fill-height)
        v-row(justify='center' align='center' no-gutters)
          bionic-metrics-spinner
    v-card.box(v-if='!loading && chartOptions')
      bionic-metrics-chart(:options='chartOptions', height='118px')
</template>
<script>
import {max, get} from 'lodash';
import Dashboard from '../api/dashboard';
import BionicMetricsChart from './Chart';
import BionicMetricsSpinner from './Spinner';
import Notifications from '../services/notification.service';

export default {
  name: 'BionicMetricsAtAGlance',
  components: {BionicMetricsSpinner, BionicMetricsChart},
  props: {
    dashboardGuid: {
      type: String,
      required: true
    }
  },
  async mounted() {
    await this.load();
  },
  computed: {
    dark() {
      return this.$vuetify.theme.dark;
    },
    splitLineColor() {
      if (this.$vuetify.theme.dark) return '#444444';
      return '#EEEEEE';
    },
    greenColor() {
      const theme = this.dark ? 'dark' : 'light';
      return get(this.$vuetify, `theme.themes.${theme}.success.base`, '#00C853');
    }
  },
  methods: {
    async load() {
      this.loading = true;
      try {
        this.data = await Dashboard.chart(this.dashboardGuid);
      } catch (e) {
        console.error(`AtAGlance Loading error: ${e.message}`);
        return Notifications.errorToast('Error Loading Dashboard', {duration: 30000, retry: this.load});
      }
      this.chartOptions = {
        tooltip: {
          trigger: 'axis',
          formatter(params) {
            const date = new Date(params[0].axisValue);
            // Add one day since mongo is based on lower-bound query which shows yesterday
            const options = {year: 'numeric', month: 'short', day: 'numeric'};
            const dateStr = date.toLocaleDateString('en-US', options);
            let rows = '';
            for (let i = 0; i < params.length; ++i) {
              let name = params[i].seriesName;
              if (params[i].seriesName === 'Passing') name = 'Passed';
              if (params[i].seriesName === 'Failing') name = 'Failed';
              rows += `<tr><td class="ataglance-indicator" style="background-color:${params[i].color};"></td><td class="atagance-cell-min">${params[i].data}</td><td>${name}</td></tr>`;
            }
            const tooltip = `<table>${dateStr}${rows}</table>`;
            return tooltip;
          },
          position(point, params, dom, rect, size) {
            // fixed at top
            if (point[0] > size.viewSize[0] / 2) {
              return [point[0] - 112, '10%'];
            }
            return [point[0] + 20, '10%'];
          },
          axisPointer: {
            type: 'shadow',
            label: {
              backgroundColor: '#6a7985'
            }
          }
        },
        grid: {
          x: 0,
          y: 0,
          x2: 0,
          y2: 0
        },
        xAxis: {
          data: this.data.dataAxis,
          axisTick: {
            show: false
          },
          axisLine: {
            show: false
          },
          axisLabel: {
            show: false
          },
          z: 10
        },
        yAxis: {
          max: max(this.data.total),
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            show: false,
            textStyle: {
              color: '#999'
            }
          },
          splitLine: {
            lineStyle: {
              color: this.splitLineColor
            }
          }
        },
        dataZoom: [{
          type: 'inside'
        }],
        series: [
          {
            type: 'bar',
            barCategoryGap: '1%',
            stack: 'day',
            name: 'Failing',
            itemStyle: {
              normal: {
                color: '#D84315'
              }
            },
            data: this.data.failing
          }, {
            type: 'bar',
            stack: 'day',
            name: 'Warning',
            itemStyle: {
              normal: {
                color: '#FF9800'
              }
            },
            data: this.data.warning
          }, {
            type: 'bar',
            stack: 'day',
            name: 'Passing',
            itemStyle: {
              normal: {
                color: this.greenColor
              }
            },
            data: this.data.passing
          }, {
            type: 'bar',
            stack: 'day',
            name: 'No Results',
            itemStyle: {
              normal: {
                color: '#CFD8DC'
              }
            },
            data: this.data.noResults
          }]
      };
      this.loading = false;
    }
  },
  data() {
    return {
      loading: false,
      data: null,
      chartOptions: null
    };
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.atagance-cell-min {
  min-width: 20px;
}

.box {
  height: 118px;
  max-height: 118px;
  min-height: 118px;
}

.ataglance-indicator {
  display: inline-block;
  margin-right: 5px;
  border-radius: 10px;
  width: 10px;
  height: 10px;
}
</style>
